import styled from 'styled-components';
import {
  TradingNewWrapper,
  ContentArea,
  TradingNewFormWrap,
  TradingFormCard,
  StyledFormWrapper,
  ButtonContainer,
} from '../New/styles';

export {
  TradingNewWrapper,
  ContentArea,
  TradingNewFormWrap,
  TradingFormCard,
  StyledFormWrapper,
  ButtonContainer,
};

export const ImportFieldsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: 768px) {
    gap: 24px;
  }
`;

export const FileUploadZone = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const FileUploadLabel = styled.span`
  display: block;
  color: #b0b0b0;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
`;

export const FileUploadBox = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 120px;
  padding: 20px 16px;
  border-radius: 12px;
  border: 2px dashed rgba(0, 212, 255, 0.35);
  background: rgba(0, 212, 255, 0.06);
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: rgba(242, 146, 5, 0.55);
    background: rgba(242, 146, 5, 0.08);
    box-shadow: 0 0 24px rgba(242, 146, 5, 0.12);
  }

  input[type='file'] {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    pointer-events: none;
  }
`;

export const FileUploadPrompt = styled.span`
  color: #e0e0e0;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
`;

export const FileUploadHint = styled.span`
  color: #888;
  font-size: 13px;
  text-align: center;
`;

/** Resumo pós-upload: cartões com ícone + hierarquia clara */
export const ImportSummaryPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;

  @media (min-width: 768px) {
    gap: 14px;
  }
`;

const importStatRowBase = `
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(12, 16, 36, 0.72);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  @media (min-width: 768px) {
    padding: 18px 22px;
    gap: 16px;
  }

  &:hover {
    border-color: rgba(255, 255, 255, 0.14);
  }
`;

export const ImportSummaryStat = styled.div`
  ${importStatRowBase}
`;

export const ImportSummaryStatHero = styled.div`
  ${importStatRowBase}
  margin-top: 2px;
  padding: 18px 18px;
  background: linear-gradient(
    145deg,
    rgba(0, 212, 255, 0.12) 0%,
    rgba(18, 22, 46, 0.94) 45%,
    rgba(22, 28, 52, 0.9) 100%
  );
  border: 1px solid rgba(0, 212, 255, 0.34);
  box-shadow:
    0 10px 32px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 0 36px rgba(0, 212, 255, 0.1);

  @media (min-width: 768px) {
    padding: 22px 24px;
  }

  &:hover {
    border-color: rgba(0, 212, 255, 0.48);
    box-shadow:
      0 12px 36px rgba(0, 0, 0, 0.42),
      inset 0 1px 0 rgba(255, 255, 255, 0.08),
      0 0 40px rgba(0, 212, 255, 0.14);
  }
`;

export const ImportStatIcon = styled.div`
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;

  @media (min-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
`;

export const ImportStatIconTrades = styled(ImportStatIcon)`
  background: rgba(242, 146, 5, 0.14);
  border: 1px solid rgba(242, 146, 5, 0.38);
  color: #ffc266;
  box-shadow: 0 0 22px rgba(242, 146, 5, 0.12);
`;

export const ImportStatIconProfit = styled(ImportStatIcon)`
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  color: #5ce1ff;
`;

export const ImportStatIconBalance = styled(ImportStatIcon)`
  background: rgba(0, 212, 255, 0.2);
  border: 1px solid rgba(0, 212, 255, 0.48);
  color: #9ff0ff;
  box-shadow: 0 0 26px rgba(0, 212, 255, 0.18);
`;

export const ImportStatMain = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ImportStatLabel = styled.span`
  display: block;
  color: #a8a8bc;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

export const ImportStatValue = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: #f4f4f6;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  text-align: right;
  flex-shrink: 0;

  @media (min-width: 768px) {
    font-size: 19px;
  }
`;

export const ImportStatValueHero = styled(ImportStatValue)`
  font-size: 19px;
  color: #8cf0ff;
  text-shadow: 0 0 20px rgba(0, 212, 255, 0.22);

  @media (min-width: 768px) {
    font-size: 22px;
  }
`;

/** Estado “importando”: cartão alinhado ao resumo (laranja + escuro) */
export const ImportProgressPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 18px;
  margin-top: 28px;
  padding: 32px 22px 36px;
  border-radius: 16px;
  background: linear-gradient(
    165deg,
    rgba(242, 146, 5, 0.11) 0%,
    rgba(12, 16, 36, 0.94) 42%,
    rgba(18, 22, 46, 0.97) 100%
  );
  border: 1px solid rgba(242, 146, 5, 0.32);
  box-shadow:
    0 12px 36px rgba(0, 0, 0, 0.42),
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 0 44px rgba(242, 146, 5, 0.09);

  @media (min-width: 768px) {
    margin-top: 36px;
    padding: 36px 28px 40px;
    gap: 20px;
  }
`;

export const ImportProgressIcon = styled.div`
  flex-shrink: 0;
  width: 54px;
  height: 54px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #ffc266;
  background: rgba(242, 146, 5, 0.16);
  border: 1px solid rgba(242, 146, 5, 0.42);
  box-shadow: 0 0 28px rgba(242, 146, 5, 0.15);
  animation: importProgressPulse 1.8s ease-in-out infinite;

  @keyframes importProgressPulse {
    0%,
    100% {
      transform: scale(1);
      box-shadow: 0 0 28px rgba(242, 146, 5, 0.15);
    }
    50% {
      transform: scale(1.04);
      box-shadow: 0 0 36px rgba(242, 146, 5, 0.22);
    }
  }
`;

export const ImportProgressHeading = styled.h3`
  margin: 0;
  color: #f0f0f4;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.45;
  max-width: 340px;

  @media (min-width: 768px) {
    font-size: 17px;
  }
`;

export const ImportProgressRingWrap = styled.div`
  position: relative;
  padding: 6px 0 2px;
  filter: drop-shadow(0 4px 16px rgba(242, 146, 5, 0.28));

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.06);
    z-index: 0;
  }

  & > * {
    position: relative;
    z-index: 1;
  }
`;

export const ImportProgressFootnote = styled.p`
  margin: 0;
  color: #8e8e9e;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
  max-width: 300px;

  @media (min-width: 768px) {
    font-size: 13.5px;
  }
`;
